// V2 (v3.ltng.app) CMS pages, read through the `public-new` router.
//
// Base URL already carries the /v2 prefix (see nuxt.config `ltngApi`). Public
// reads need only account_id (+ optional furl); no mgmt/token for content.
//
// Why `public-new` and NOT `public`: the old `/public/*` router is ~10x faster
// (~0.23s vs ~2.7s) but serves STALE data and its caching cannot be corrected —
// that bit OMT VIP. `/public-new/*` is `cache-control: no-store`, so it is
// always fresh but currently uncached (hence slow). A proper caching strategy
// is planned for `public-new`; staying on it means this site inherits that work.
// Do not "optimize" these back to `/public`.
//
// `content` is normalized from the V3 block structure to the raw HTML string the
// frontend renders (see utils/pageContent.js) so v-html works unchanged.
import { blocksToHtml } from '../../utils/pageContent'

function normalizePage(page) {
  if (page && page.content !== undefined) {
    page.content = blocksToHtml(page.content)
  }
  return page
}

export default function (axios) {
  return {
    getPages(params) {
      return axios.get('/public-new/cms/pages', params).then((res) => {
        const results = res && res.data && res.data.results
        if (Array.isArray(results)) results.forEach(normalizePage)
        return res
      })
    },

    getPage(id, params) {
      return axios.get(`/public-new/cms/pages/${id}`, params).then((res) => {
        if (res && res.data) normalizePage(res.data)
        return res
      })
    },
  }
}
